export default {
    DEV_LOCAL: 'dev-local',
    DEVELOPMENT: 'development',
    UAT: 'uat',
    PRODUCTION: 'production',
    nonprod: 'development', // key expected from REACT_APP_ENV env
    uat: 'uat', // key expected from REACT_APP_ENV env
    prod: 'prod', // key expected from REACT_APP_ENV env
};
